import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { usePermissions } from './permissions';

// Горячие клавиши менеджера (не работают, пока курсор в поле ввода или открыто окно):
//   /        — поиск и команды (как Ctrl+K)
//   N        — новая сделка (в первой воронке)
//   G, затем: D — главная, C — контакты, T — задачи, I — входящие, P — звонки, A — аналитика, E — обучение, F — первая воронка
// Привязка к физическим клавишам (e.code): работают и на русской, и на узбекской раскладке.
const GO = { KeyD: ['dashboard', '/dashboard'], KeyC: ['contacts', '/contacts'], KeyT: ['tasks', '/tasks'], KeyI: ['inbox', '/inbox'], KeyP: ['calls', '/calls'], KeyA: ['analytics', '/analytics/sales'], KeyE: ['education', '/education'] };

export function useHotkeys({ onSearch }) {
  const navigate = useNavigate();
  const { canSeeModule, can } = usePermissions();
  const funnels = useSelector((s) => s.funnels.list);

  useEffect(() => {
    let armed = false;
    let timer = null;
    const disarm = () => { armed = false; clearTimeout(timer); };
    const onKey = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey || e.defaultPrevented) return;
      const el = e.target;
      if (el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName))) return;
      if (document.querySelector('[data-dialog-ready]')) return;
      if (e.code === 'Slash' && !e.shiftKey) { e.preventDefault(); onSearch(); return; }
      if (armed) {
        disarm();
        if (e.code === 'KeyF') { if (canSeeModule('funnels') && funnels[0]) { e.preventDefault(); navigate(`/funnel/${funnels[0]._id}`); } return; }
        const target = GO[e.code];
        if (target && canSeeModule(target[0])) { e.preventDefault(); navigate(target[1]); }
        return;
      }
      if (e.code === 'KeyG') { armed = true; timer = setTimeout(disarm, 1200); return; }
      if (e.code === 'KeyN' && canSeeModule('funnels') && can('funnels', 'create') && funnels[0]) { e.preventDefault(); navigate(`/funnel/${funnels[0]._id}/deal/new`); }
    };
    document.addEventListener('keydown', onKey);
    return () => { disarm(); document.removeEventListener('keydown', onKey); };
  }, [navigate, canSeeModule, can, funnels, onSearch]);
}
